import React, {Component} from "react";
import {Field, reduxForm} from "redux-form/immutable";
import ActionButton from "../../components/ActionButton";
import FormFieldsTable from "../../components/forms/FormFieldsTable";
import FormError from "../../components/forms/FormError";
import BooleanInputField from "../../components/forms/BooleanInputField";

function toBoolean(val) {
  return val === true || val === "true";
}

class Change8PackPreferenceForm extends Component {

  render() {
    let {errors, handleSubmit, submit, submitting} = this.props;
    let submitLabel = submitting ? "Standby..." : "Submit"; 
    return (
      <form onSubmit={handleSubmit}>
        <div className="fields">
          <FormFieldsTable>
            <Field
              label="Strategy for 8 pack EOL"
              yesLabel="Match bottles (default)"
              noLabel="Match cases"
              name="matchBottles"
              type="boolean"
              component={BooleanInputField}
              serverError={this.props.errors.matchBottles}
              normalize={toBoolean}
              />
          </FormFieldsTable>
        </div>
        <FormError error={errors._error} />
        <div className="buttons">
          <ActionButton label={submitLabel} onClick={submit} active={!submitting} />
          <ActionButton label="Cancel" active={!submitting} onClick={this.props.onCancel} />
        </div>
      </form>
    )
  }
}

const ReduxForm = reduxForm({
  form: "Change8PackPreferenceForm"
})(Change8PackPreferenceForm);

export default ReduxForm;